import { useAtomValue as s } from "jotai";
import { cartItemsAtom as p } from "./index34.mjs";
import { totalAdultsAtom as C, totalChildrenAtom as f } from "./index26.mjs";
import { useState as x, useCallback as h, useEffect as A } from "react";
const O = () => {
  const e = s(p), c = s(C), o = s(f), [n, l] = x(!1), r = h(() => {
    if (e.length === 0)
      return !0;
    const u = c + o, m = e.reduce(
      (a, t) => a + t.maxOccupancy,
      0
    ), d = e.reduce(
      (a, t) => a + t.maxAdults,
      0
    ), i = e.reduce(
      (a, t) => a + (t.maxChildren === null ? t.maxOccupancy : t.maxChildren),
      0
    );
    return u <= m && c <= d && o <= i;
  }, [e, c, o]);
  return A(() => {
    l(r());
  }, [r]), n;
};
export {
  O as useCapacityCheck
};
